import { AppFooter } from './AppFooter';
import { AppHeader } from './AppHeader';
import { Form } from './Form';
import { PageContent } from './PageContent';

type StyledFromContainerProps = {
  children: React.ReactNode;
  title: string;
};
export const StyledFromContainer: React.FC<StyledFromContainerProps> = (props) => {
  return (
    <>
      <AppHeader />
      <PageContent>
        <Form title={props.title}>{props.children}</Form>
      </PageContent>
      <AppFooter />
    </>
  );
};
